// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1WrDJ","content":"LoadingAlert_content__2SLsK"};